// Keep the native select and keyboard behavior; only size it to its selected label.
if (!customElements.get('ac-collection-sort')) {
  customElements.define('ac-collection-sort', class extends HTMLElement {
    connectedCallback() {
      this.onChange = () => {
        const select = this.querySelector('select');
        const label = this.querySelector('.ac-collection-sort__label');
        if (select && label) label.textContent = select.selectedOptions[0]?.textContent.trim() || '';
      };
      this.addEventListener('change', this.onChange);
      this.onChange();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }
  });
}
